import { RouterProvider } from '@tanstack/react-router';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from '@/providers';
import { router } from '@/router';
import { SupplierRealtimeNotifications } from '@/realtime/supplier-realtime-notifications';

// Polices self-host (CSP-safe, aucun CDN) — fontsource variable, axe wght roman.
// Familles : « Inter Variable » / « Source Serif 4 Variable » / « JetBrains Mono Variable ».
// L'accent italique de Source Serif 4 (titres) sera chargé en Phase 2 avec le PageHeader.
import '@fontsource-variable/inter';
import '@fontsource-variable/source-serif-4';
import '@fontsource-variable/jetbrains-mono';

import '@/index.css';

// =============================================================================
// main.tsx — Point d'entrée SPA. Monte les providers puis le router.
// =============================================================================
const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Élément racine #root introuvable.');
}

// `bootstrap` : résolution DYNAMIQUE de la session fournisseur RÉELLE au montage (whoami + me),
// fallback interim admin si aucune session (P-ROLE-INTERIM=a, S0-ROLE). Les tests injectent `auth`.
createRoot(rootElement).render(
  <React.StrictMode>
    <AppProviders bootstrap>
      {/* Abonnement temps réel (R15-COM-06) : monté hors router, sous les providers. Actif fournisseur
          uniquement (interne). Signale le bandeau + invalide les queries à réception du signal socket. */}
      <SupplierRealtimeNotifications />
      <RouterProvider router={router} />
    </AppProviders>
  </React.StrictMode>,
);
